import React, { Component } from "react";
import clsx from 'clsx';
import { FormControlLabel, FormLabel, RadioGroup, FormHelperText, FormControl, Radio } from "@material-ui/core";

class AdditionalOrderType extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
        this.setState({ errors: '' });
    }

    render() {

        return (
            <React.Fragment>
                <span className={clsx(this.props.classes.textFieldContainer, this.props.classes.paymentMethodContainer)} style={{ marginTop: 20 }}>
                    <FormControl component="fieldset" error={this.props.omdata.customErrors && this.props.omdata.customErrors.additional_order_type} >
                        <FormLabel component="legend" className={this.props.classes.orderLabel}>{this.props.translations.cart_delivery.choose_order_type}:</FormLabel>
                        <RadioGroup row aria-label="position" name="additional_order_type" value={this.props.omdata.additional_order_type}> {/* defaultValue="cash" */}

                            <FormControlLabel
                                value={'preorder'}
                                control={<Radio className={this.props.classes.orderRadio} onClick={(e) => this.props.onChange(e)} />}
                                label={this.props.translations.cart_delivery.order_type_preorder}
                            />

                            <FormControlLabel
                                value={'delivery'}
                                control={<Radio className={this.props.classes.orderRadio} onClick={(e) => this.props.onChange(e)} />}
                                label={this.props.translations.cart_delivery.order_type_delivery}
                            />

                        </RadioGroup>
                        <FormHelperText>{this.props.omdata.customErrors && this.props.omdata.customErrors.additional_order_type ? this.props.omdata.customErrors.additional_order_type : ''}</FormHelperText>
                    </FormControl>
                </span>
            </React.Fragment>
        )
    }

}

export default AdditionalOrderType;
